import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header card-header-jaya" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "svg-icon svg-icon-2x" }
const _hoisted_5 = { class: "d-flex flex-column align-items-center justify-content-between" }
const _hoisted_6 = { class: "w-100 d-flex flex-column align-items-center" }
const _hoisted_7 = { class: "d-flex flex-row border-bottom w-100" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_9 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_10 = {
  key: 1,
  style: {"height":"500px"}
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fst-italic text-dark text-end me-2 px-5 w-100" }, " Cliquez sur les données du graphique pour obtenir plus d'informations ", -1)
const _hoisted_12 = { class: "py-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center" }, "Filtres sélectionnés", -1)
const _hoisted_14 = {
  id: "",
  class: "row m-2"
}
const _hoisted_15 = { class: "col-sm-4 mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: -1 }, "Tout OTEX confondu", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Sans OTEX", -1)
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-sm-4 mb-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: -1 }, "Tout SIQO confondu", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Sans SIQO", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "col-sm-4 mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: -1 }, "France entière", -1)
const _hoisted_25 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_FactorLegend = _resolveComponent("FactorLegend")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_card_title_jaya, {
        "duotune-icon": "graphs/gra009",
        title: "Comparer avec des références"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "infos-button cursor-pointer",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSwal && _ctx.openSwal(...args)))
        }, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, {
              src: 
                require('@/../public/media/icons/duotune/general/gen046.svg')
              
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("a", {
            class: _normalizeClass([_ctx.chartType === 'bar' ? `btn-light-primary` : ``, "btn btn-white btn-active-light-primary btn-active-icon-primary btn-active-text-primary w-50 rounded-0"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setType('bar')))
          }, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg, {
                src: 
                  require('@/../public/media/icons/duotune/graphs/gra004.svg')
                
              }, null, 8, ["src"])
            ]),
            _createTextVNode("Bâtons")
          ], 2),
          _createElementVNode("a", {
            class: _normalizeClass([_ctx.chartType === 'radar' ? `btn-light-primary` : ``, "btn btn-white btn-active-light-primary btn-active-icon-primary btn-active-text-primary w-50 rounded-0"]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setType('radar')))
          }, [
            _createElementVNode("span", _hoisted_9, [
              _createVNode(_component_inline_svg, {
                src: 
                  require('@/../public/media/icons/duotune/graphs/gra008.svg')
                
              }, null, 8, ["src"])
            ]),
            _createTextVNode("Radar")
          ], 2)
        ]),
        (_ctx.displayChart)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              options: _ctx.chartType === 'radar' ? _ctx.chartOptionsRadar : _ctx.chartOptionsBar,
              series: _ctx.series,
              type: 
            _ctx.chartType === 'radar'
              ? _ctx.chartOptionsRadar.chart.type
              : _ctx.chartOptionsBar.chart.type
          ,
              height: "500",
              class: "col-12 px-0 px-md-5",
              onDataPointSelection: _ctx.displayFactorDetail
            }, null, 8, ["options", "series", "type", "onDataPointSelection"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10)),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingOTEX.id) = $event)),
                "aria-label": "Selection OTEX",
                class: "form-select form-control form-control-lg form-control-solid",
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getNewAverage && _ctx.getNewAverage(...args)))
              }, [
                _hoisted_16,
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOTEX.sort((a, b) => (a.id < b.id ? -1 : 1)), (otex) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: otex.id,
                    value: otex.id
                  }, " OTEX : " + _toDisplayString(otex.name), 9, _hoisted_18))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.editingOTEX.id]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingSIQO.id) = $event)),
                "aria-label": "Selection SIQO",
                class: "form-select form-control form-control-lg form-control-solid",
                onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.getNewAverage && _ctx.getNewAverage(...args)))
              }, [
                _hoisted_20,
                _hoisted_21,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSIQO.sort((a, b) =>
                    a.name < b.name ? -1 : 1
                  ), (siqo) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: siqo.id,
                    value: siqo.id
                  }, _toDisplayString(siqo.name), 9, _hoisted_22))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.editingSIQO.id]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingDepartment.id) = $event)),
                "aria-label": "Selection SIQO",
                class: "form-select form-control form-control-lg form-control-solid",
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getNewAverage && _ctx.getNewAverage(...args)))
              }, [
                _hoisted_24,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.departments, (department) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: department.id,
                    value: department.id
                  }, _toDisplayString(department.insee_dep) + " - " + _toDisplayString(department.name), 9, _hoisted_25))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.editingDepartment.id]
              ])
            ])
          ])
        ]),
        _createVNode(_component_FactorLegend, {
          factors: _ctx.factors ? _ctx.factors : [],
          class: "p-5 col-12 col-lg-6"
        }, null, 8, ["factors"])
      ])
    ])
  ]))
}